import PropTypes from 'prop-types';

export default PropTypes.shape({
    offset: PropTypes.number.isRequired,
    duration: PropTypes.number.isRequired,
});
